import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'it',
    fullName: 'Italian',
    nativeName: 'Italiano',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Qualcosa di straordinario sta arrivando",
    landing_subtitle: "ArgVoid è uno studio di sviluppo di app e giochi. Restate sintonizzati, presto arriveranno novità!",
    select_language: "Seleziona lingua",
    search_placeholder: "Cerca lingue...",
    terms_title: "Termini di servizio",
    policy_title: "politica sulla riservatezza",
    cookies_title: "Politica sui cookie",
    terms_content: `
        <strong>1. Accettazione dei Termini</strong><br>
        Accedendo ad ArgVoid si accettano i presenti Termini di servizio. Se questi termini non vengono accettati, il servizio non deve essere utilizzato.<br><br>

        <strong>2. Utilizzo della piattaforma</strong><br>
        ArgVoid e le sue applicazioni sono fornite "così come sono" per scopi informativi e creativi. Il servizio deve essere utilizzato solo per scopi legittimi.<br><br>

        <strong>3. Condotta vietata</strong><br>
        È severamente vietato sfruttare le vulnerabilità del sito, inviare spam o tentare l'accesso non autorizzato all'infrastruttura.<br><br>

        <strong>4. Dichiarazione di non responsabilità</strong><br>
        La piattaforma e i servizi possono essere modificati in qualsiasi momento senza preavviso. Non viene fornita alcuna garanzia in merito al tempo di attività o alla disponibilità del servizio.
    `,
    policy_content: `
        <strong>1. Raccolta informazioni</strong><br>
        Al momento la piattaforma non richiede l'autenticazione dell'utente o la creazione di un account. Nessuna informazione di identificazione personale (come nomi o indirizzi e-mail) viene raccolta attivamente dai visitatori.<br><br>

        <strong>2. Dati di utilizzo</strong><br>
        È possibile raccogliere analisi di base e anonime per comprendere il traffico del sito e migliorare le applicazioni. Questi dati non sono collegati alle identità dei singoli utenti.<br><br>

        <strong>3. Servizi di terze parti</strong><br>
        Per i servizi di hosting e di analisi possono essere utilizzati fornitori di terze parti. Le pratiche sulla privacy di questi rispettivi fornitori regolano i dati anonimi trattati sulla loro infrastruttura.<br><br>

        <strong>4. Sicurezza dei dati</strong><br>
        Sono implementate ragionevoli misure di sicurezza per proteggere la piattaforma. Tuttavia, nessun metodo di trasmissione su Internet è completamente sicuro.<br><br>
    `,
    cookies_content: `
        <strong>1. Cosa sono i cookie e l'archiviazione locale?</strong><br>
        I cookie e l'archiviazione locale del browser sono piccoli file di dati archiviati sul dispositivo per ricordare le preferenze di configurazione durante le visite.<br><br>

        <strong>2. Scopo d'uso</strong><br>
        Browser LocalStorage viene utilizzato esclusivamente per salvare le impostazioni di configurazione, come: <br>
        - Preferenze lingua<br>
        - Configurazione dell'interfaccia utente (ad esempio, impostazioni del layout o del tema)<br>
        - Cache temporanea dell'applicazione<br><br>

        <strong>3. Nessun tracciamento</strong><br>
        I cookie e l'archiviazione locale non vengono utilizzati per scopi pubblicitari o di tracciamento di terze parti. Tutti i dati memorizzati sono strettamente legati alle funzionalità principali della piattaforma.<br><br>

        <strong>4. Controllo</strong><br>
        I dati del browser possono essere cancellati in qualsiasi momento tramite le impostazioni del browser, che ripristineranno eventuali configurazioni locali.
    `,
    cookie_consent_text: "Utilizziamo cookie di base per garantire il corretto funzionamento del sito Web, ad esempio mantenendo attiva la sessione, salvando la preferenza della lingua e altre configurazioni personalizzate.",
    read_policy: "Leggi la Politica sui cookie",
    support_title: "Contatta l'assistenza",
    support_subject_label: "Soggetto",
    support_message_label: "Messaggio",
    support_submit_button: "Invia messaggio",
    support_hint: "Nota: questo aprirà l'applicazione di posta elettronica predefinita per inviare il messaggio.",
    support_success_msg: "Apertura dell'app di posta elettronica...",
    support_error_msg: "Impossibile inviare il messaggio. Per favore riprova più tardi.",
    explorer_title: "Esploratore",
    history_title: "Storia",
    animation_title: "Animazione",
    config_title: "Configurazione",
    tool_mouse: "Seleziona (Ctrl+M)",
    tool_brush: "Pennello (Ctrl+B)",
    tool_brush_mode: "Modalità di commutazione (Solido/Cancella)",
    tool_eraser: "Gomma (Ctrl+E)",
    tool_brush_size: "Regola la dimensione del pennello",
    tool_bucket: "Riempi (Ctrl+F)",
    tool_eyedropper: "Contagocce",
    tool_grid: "Griglia (Ctrl+Maiusc+B)",
    tool_rotate: "Ruota (Ctrl+Maiusc+R)",
    tool_flip_h: "Capovolgi H (Ctrl+Maiusc+H)",
    tool_flip_v: "Capovolgi V (Ctrl+Maiusc+V)",
    tool_transpose: "Trasponi (Ctrl+Maiusc+T)",
    label_width: "Larghezza",
    label_height: "Altezza",
    label_frames: "Numero di fotogrammi",
    label_animation: "Stile di animazione",
    label_background_color: "Colore di sfondo",
    label_interval: "Intervallo",
    tool_anim_config: "Configurazione dell'animazione",
    label_new_width: "Nuova larghezza",
    label_new_height: "Nuova altezza",
    label_apply: "Fare domanda a",
    label_colors: "Colori",
    label_size: "Misurare",
    label_tolerance: "Tolleranza",
    val_horizontal: "Orizzontale",
    val_vertical: "Verticale",
    val_sequence: "Sequenza",
    val_bounce: "Rimbalzo",
    val_random: "Casuale",
    val_solid: "Solido",
    val_clear: "Chiaro",
    action_add_sheet: "Nuovo foglio",
    action_import: "Importare",
    action_export: "Esportare",
    action_sort_projects: "Ordinare",
    sort_date_old: "Prima il più vecchio",
    sort_date_new: "Prima il più recente",
    sort_name_az: "Nome (A-Z)",
    sort_name_za: "Nome (Z-A)",
    action_new_sprite: "Nuovo Folletto",
    action_new_project: "Nuovo progetto",
    modal_save_all_title: "Salva tutte le modifiche",
    modal_save_all_desc: "Seleziona le risorse da salvare:",
    modal_save_selected: "Salva selezionato",
    action_saved: "Salvato",
    modal_create_sprite_title: "Crea nuovo sprite",
    modal_create_project_title: "Crea nuovo progetto",
    modal_add_sheet_title: "Aggiungi nuovo foglio",
    modal_rename_sheet_title: "Rinomina foglio",
    modal_rename_sprite_title: "Rinomina Sprite",
    modal_delete_sprite_title: "Elimina Sprite",
    modal_delete_project_title: "Elimina progetto",
    modal_delete_sheet_title: "Elimina foglio",
    placeholder_sprite_name: "Nome",
    placeholder_project_name: "Nome",
    placeholder_sheet_name: "Nome",
    placeholder_new_name: "Nuovo nome",
    action_create: "Creare",
    action_add: "Aggiungere",
    action_rename: "Rinominare",
    action_duplicate: "Duplicato",
    action_delete: "Eliminare",
    action_cancel: "Cancellare",
    confirm_delete_sprite: "Sei sicuro di voler eliminare questo sprite?",
    confirm_delete_project: "Sei sicuro di voler eliminare questo progetto? Tutti gli sprite verranno rimossi.",
    confirm_delete_sheet: "Sei sicuro di voler eliminare questo foglio?",
    err_select_sprite: "Seleziona prima uno sprite.",
    err_select_project: "Seleziona prima un progetto.",
    err_name_empty: "Il nome non può essere vuoto.",
    err_sprite_exists: "Esiste già uno sprite con quel nome.",
    err_project_exists: "Esiste già un progetto con quel nome.",
    err_no_content: "Nessun contenuto da salvare.",
    err_no_changes: "Nessuna modifica da salvare.",
    err_delete_last_sheet: "Impossibile eliminare l'ultimo foglio.",
    err_extract_frames: "Impossibile estrarre alcun frame.",
    err_indexeddb: "Impossibile salvare localmente. Il tuo browser potrebbe non supportare IndexedDB.",
    msg_upload_success: "Caricamento riuscito: {0}",
    msg_upload_failed: "Caricamento non riuscito: {0}",
    msg_save_success: "Salvataggio riuscito.",
    msg_saving: "Risparmio...",
    msg_multi_save_result: "{0} risorse salvate. {1} errori.",
    menu_title: "Menu",
    menu_save: "Salva",
    menu_save_all: "Salva tutto",
    menu_support: "Contatta l'assistenza",
    label_local_storage: "Archiviazione locale",
    label_sign_in: "Registrazione",
    modal_export_title: "Esporta Sprite",
    label_filename: "Nome file",
    label_format: "Formato",
    action_export_confirm: "Esportare",
};

export default translations;
